import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export const useDeleteTestimonial = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (id: string) => {
			try {
				const { data } = await api.delete(`/management/testimonial/delete/${id}`);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao deletar depoimento');
			}
		},
		onSuccess: (_, id) => {
			queryClient.invalidateQueries({ queryKey: ['testimonials'] });
			queryClient.removeQueries({ queryKey: ['testimonial', id] });
		},
		onError: error =>
			console.error('Erro ao deletar depoimento:', getApiErrorMessage(error, 'Erro ao deletar depoimento')),
	});
};
